import { FC } from 'react';

import Image from 'next/image';
import { SingleValueProps } from 'react-select';

import { LanguageOption } from './locale-picker.types';

export const LocalePickerSingleValue: FC<SingleValueProps<LanguageOption, false>> = ({
  getValue
}) => {
  const [selectedFlagValue] = getValue();

  return <Image src={selectedFlagValue.icon} alt={`${selectedFlagValue.label} flag`} />;
};
